import React from "react";
import "../students/students.css";

import { Outlet } from "react-router-dom";
import BaseTemplate from "components/shared/BaseTemplate";

export default function Teachers() {
  return (
    <BaseTemplate>
      <Outlet />
    </BaseTemplate>
  );
}
